import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/LandingPage.css';
import '../styles/NotFoundPage.css';
import PublicNav from './PublicNav';

// Hosting rewrites EVERY path to the app shell, so an unmatched route is not a
// 404 from the server -- it reaches React and renders whatever <Routes> decides.
// With no catch-all that was nothing at all: a mistyped or stale SiteSift link
// showed a blank dark page with no message and no way back, on a public domain.
// This route is the floor: any path the app does not know still lands somewhere
// that says where it is and offers a way out.
export default function NotFoundPage() {
  return (
    <div className="landing-page">
      <PublicNav />

      <section className="notfound-hero" role="main">
        <p className="notfound-hero__code">404</p>
        <h1>This page doesn’t exist</h1>
        <p className="notfound-hero__body">
          The link may be mistyped, or it may point at a page that has moved.
          Nothing has gone wrong with your account or your campaigns.
        </p>

        <div className="notfound-hero__actions">
          <Link className="notfound-hero__primary" to="/">Back to home</Link>
          <Link className="notfound-hero__secondary" to="/dashboard">Go to my dashboard</Link>
        </div>
      </section>
    </div>
  );
}
